import * as moment from 'moment';
import { Symptom } from '../symptoms/symptom';

const camelcaseKeysDeep = require('camelcase-keys-deep');

export class Queue {
  id: string;
  createdDate: string;
  updatedDate: string;
  visit: string;
  priority: number;
  locked: boolean;
  lockedProvider: string;
  lockedDatetime: string;
  patientName: string;
  patientDob: string;
  patientGender: string;
  gender: string;
  patientAge: string;
  primaryComplaint: string;
  complaintDuration: string;
  previouslyDiagnosed: boolean;
  symptoms: any;
  symptomNames: string;
  skipTimerEnd;
  skipTimerLength = 120;

  constructor(visitInfo: any) {
    visitInfo = camelcaseKeysDeep(visitInfo);

    this.id = visitInfo.id || visitInfo.visit;
    this.createdDate = visitInfo.createdDate;
    this.updatedDate = visitInfo.updatedDate;
    this.visit = visitInfo.visit;
    this.priority = visitInfo.priority;
    this.locked = visitInfo.locked;
    this.lockedProvider = visitInfo.lockedProvider;
    this.lockedDatetime = visitInfo.lockedDatetime;
    this.patientName = visitInfo.patientName;
    this.patientDob = visitInfo.patientDob;
    this.patientGender = visitInfo.patientGender;
    this.patientAge = visitInfo.patientAge;
    this.primaryComplaint = visitInfo.primaryComplaint;
    this.complaintDuration = visitInfo.complaintDuration;
    this.previouslyDiagnosed = visitInfo.previouslyDiagnosed;
    this.symptoms = visitInfo.latestSymptoms && visitInfo.latestSymptoms.map((latestSymptom) => {
      if (latestSymptom && typeof (latestSymptom) === 'object') {
        return new Symptom(latestSymptom);
      } else {
        return new Symptom({ id: latestSymptom });
      }
    });

    if (this.symptoms) {
      let names = this.symptoms.map((symptom) => { return symptom.name; });
      this.symptomNames = names.filter(Boolean).join(', ');
    } else {
      this.symptoms = [];
    }
  }

  get description(): string {
    let values = [];

    if (this.patientGender) { values.push(this.patientGender); }
    if (this.patientAge) { values.push(this.patientAge); }
    if (this.patientDob) { values.push(this.patientDob); }

    return values.filter(Boolean).join(', ');
  }

  get waitTime(): string {
    let now = moment();
    if (this.createdDate) {
      let wait = now.diff(this.createdDate);
      return moment.duration(wait).format('HH:mm:ss', { trim: false });
    } else {
      return '00:00:00';
    }
  }

  setSkipTimer(): void {
    this.skipTimerEnd = moment().add(this.skipTimerLength, 'seconds').toDate();
  }
}



// WEBPACK FOOTER //
// ./src/app/patient-queue/queue.ts